/**
 * Shared crypto polyfill utilities
 */

/**
 * Interface for global object with crypto property
 */
interface GlobalWithCrypto {
  crypto?: {
    randomUUID?: () => string;
  };
}

/**
 * Generates a UUID v4 string
 * @returns A valid UUID v4 format string
 */
export const generateRandomUUID = (): string => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
  const r = Math.random() * 16 | 0;
  const v = c === 'x' ? r : (r & 0x3 | 0x8);
  return v.toString(16);
});

/**
 * Polyfills crypto.randomUUID if not available
 * @param globalObject - The global object (window, global, etc.)
 */
export const polyfillCryptoRandomUUID = (globalObject: GlobalWithCrypto = global): void => {
  if (typeof globalObject.crypto === 'undefined') {
    // eslint-disable-next-line no-param-reassign
    globalObject.crypto = {};
  }

  if (typeof globalObject.crypto.randomUUID !== 'function') {
    // eslint-disable-next-line no-param-reassign
    globalObject.crypto.randomUUID = generateRandomUUID;
  }
};
